export const deceasedOptions = [
  {
    label: "Mourner's Parent",
    value: "Parent",
  },
  {
    label: "Mourner's Child",
    value: "Child",
  },
  {
    label: "Mourner's Father",
    value: "Father",
  },
  {
    label: "Mourner's Mother",
    value: "Mother",
  },
  {
    label: "Mourner's Grandchild",
    value: "Grandchild",
  },
  {
    label: "Mourner's Grandparent",
    value: "Grandparent",
  },
  {
    label: "Mourner's Brother",
    value: "Brother",
  },
  {
    label: "Mourner's Sister",
    value: "Sister",
  },
  {
    label: "Mourner's Son",
    value: "Son",
  },
  {
    label: "Mourner's Daughter",
    value: "Daughter",
  },
  {
    label: "Mourner's Wife",
    value: "Wife",
  },
  {
    label: "Mourner's Husband",
    value: "Husband",
  },
  {
    label: "Mourner's Partner",
    value: "Partner",
  },
  {
    label: "Mourner's Father-in-Law",
    value: "Father-in-law",
  },
  {
    label: "Mourner's Mother-in-law",
    value: "Mother-in-law",
  },
  {
    label: "Mourner's Brother-in-Law",
    value: "Brother-in-law",
  },
  {
    label: "Mourner's Sister-in-law",
    value: "Sister-in-law",
  },
  {
    label: "Mourner's Uncle",
    value: "Uncle",
  },
  {
    label: "Mourner's Aunt",
    value: "Aunt",
  },
  {
    label: "Mourner's Nephew",
    value: "Nephew",
  },
  {
    label: "Mourner's Niece",
    value: "Niece",
  },
  {
    label: "Mourner's Grandmother (Paternal)",
    value: "Grandmother (Patenral)",
  },
  {
    label: "Mourner's Grandfather (Paternal)",
    value: "Grandfather (Patenral)",
  },
  {
    label: "Mourner's Grandmother (Maternal)",
    value: "Grandmother (Matenral)",
  },
  {
    label: "Mourner's Grandfather (Maternal)",
    value: "Grandfather (Matenral)",
  },
  {
    label: "Mourner's Step Mother",
    value: "Step Mother",
  },
  {
    label: "Mourner's Step Father",
    value: "Step Father",
  },
  {
    label: "Mourner's Cousin",
    value: "Cousin",
  },
  {
    label: "Mourner's Friend",
    value: "Friend",
  },
  {
    label: "Mourner’s Relative",
    value: "Relative",
  },
  {
    label: "Mourner’s Grandson",
    value: "Grandson",
  },
  {
    label: "Mourner’s Granddaughter",
    value: "Granddaughter",
  },
  {
    label: "Mourner’s Son-in-Law",
    value: "Son-in-law",
  },
  {
    label: "Mourner’s Daughter-in-Law",
    value: "Daughter-in-Law",
  },
];